import { api } from "@/lib/api";

export const mget = (url, params) => api.get(`/manager${url}`, { params }).then((r) => r.data);
export const mpost = (url, body) => api.post(`/manager${url}`, body).then((r) => r.data);
export const mput = (url, body) => api.put(`/manager${url}`, body).then((r) => r.data);
export const mpatch = (url, body) => api.patch(`/manager${url}`, body).then((r) => r.data);
export const mdel = (url) => api.delete(`/manager${url}`).then((r) => r.data);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" · ");
  return d || e?.message || "Error inesperado";
};

export const fmtDate = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "—");
export const fmtDay = (iso) =>
  iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("es-ES", { weekday: "short", day: "2-digit", month: "short" }) : "";
export const eur = (n) =>
  n == null || n === "" ? "—" : Number(n).toLocaleString("es-ES", { style: "currency", currency: "EUR" });

export const EVENT_STATUS = {
  provisional: { label: "Provisional", cls: "bg-amber-100 text-amber-800 border-amber-300 border-dashed" },
  confirmed: { label: "Confirmado", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  completed: { label: "Realizado", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  cancelled: { label: "Cancelado", cls: "bg-rose-50 text-rose-700 border-rose-200 line-through" },
};
export const KIND = {
  sala: { label: "Sala", cls: "bg-[#101B28] text-[#F7F5F0]" },
  externo: { label: "Externo", cls: "bg-[#BBA77D] text-[#101B28]" },
};
export const TASK_STATUS = { pendiente: "Pendiente", en_curso: "En curso", completada: "Completada", no_aplica: "No aplica" };
export const PRIORITY = {
  alta: "bg-rose-100 text-rose-700", media: "bg-amber-100 text-amber-800", baja: "bg-slate-100 text-slate-600",
};
export const LEAD_STATUS = {
  nuevo: "Nuevo", contactado: "Contactado", presupuesto: "Presupuesto enviado", negociacion: "Negociación",
  confirmado: "Confirmado", perdido: "Perdido", cancelado: "Cancelado",
};
export const SOURCE_LABEL = { web_events: "Web · sala", web_mobile: "Web · externos", web_contact: "Web · contacto" };

export const fmtTs = (iso) =>
  iso ? new Date(iso).toLocaleString("es-ES", { timeZone: "Europe/Madrid", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";

export const todayISO = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Madrid" });
